<template>
  <div class="contents">
    <div class="title">
      <h1 v-html="$t('common.top_title', {nickname: myInfo.user_nickname})"></h1>
      <p>{{ $t('common.top_subtitle') }}</p>
    </div>
    <div class="smenu">
      <div class="mypage_sub_title">
        <a href="javascript:" @click="this.$router.back()">
          <img src="../../assets/img/btn_back.png">
        </a>{{ $t('log.title') }}
      </div>
      <div class="mypage_sub_btn">
        <a href="javascript:" :class="{now: category == 0}" @click="onCategory(0)">
          {{ $t('log.log_list_02') }}
        </a>
        <a href="javascript:" :class="{now: category == 1}" @click="onCategory(1)">
          {{ $t('log.log_list_03') }}
        </a>
      </div>
    </div>

    <div class="warp">
      <div class="my_point">
        {{ myInfo.user_nickname }}'s Poin & Roti :
        <span>{{ $t('log.point') }}<b>{{ currency(myInfo.points) }}</b></span>
        <span>{{ $t('log.cash') }}<b>{{ currency(myInfo.cash) }}</b></span>
      </div>
      <div class="hisotry_list">
        <ul>
          <li v-for="(log, idx) in logList" :key="idx">
            <b>{{
                moment(log.update_date * 1000).format('YYYY.MM.DD')
              }}</b>{{ moment(log.update_date * 1000).format('HH:mm:ss') }} <span>({{ log.reason }})</span>
            <p :class="log.value.charAt(0) == '-' ? 'minus' : 'plus'">{{ currency(log.value) }}</p>
          </li>
        </ul>
        <li>
          <InfiniteLoading :first-load="false" @infinite="getList"/>
        </li>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<style lang="scss" scoped src="./History.scss"></style>

<script>
import { requestPost, showToast } from "../../lib/util";
import { PAGE_SIZE } from "../../lib/constant";
import InfiniteLoading from 'v3-infinite-loading';

export default {
  name: 'History',
  components: {
    InfiniteLoading,
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close'],
  data() {
    let myInfo = this.$store.getters.me;
    return {
      myInfo: myInfo,
      category: 0,
      logList: [],
      loadingEnd: false,
    }
  },
  mounted() {
    this.logList = [];
    this.loadingEnd = false;
    this.initList();
  },
  methods: {
    onKeyPress: function (e) {
      if (e.keyCode == 27) {
        this.$emit('close');
      }
    },
    onCategory: function (_category) {
      this.category = _category;
      this.initList();
    },
    initList: function () {
      this.logList = [];
      this.loadingEnd = false;

      this.getList();
    },
    getList: function ($state) {
      let _app = this;
      if (this.loadingEnd) {
        return;
      }
      if (this.category == 0) {
        requestPost(
          'user/getUserPointList',
          {
            uid: this.myInfo.uid,
            offset: this.logList.length,
            limit: PAGE_SIZE
          },
          response => {
            _app.loadingEnd = response.point_list.length < PAGE_SIZE;
            _app.logList = _app.logList.concat(response.point_list);
            if ($state) {
              if (_app.loadingEnd) {
                $state.complete();
              }
              $state.loaded();
            }
          },
          (code, msg) => {
            showToast(msg);
            if ($state) {
              $state.loaded();
            }
          }
        );
      } else {
        requestPost(
          'user/getUserCashList',
          {
            uid: _app.myInfo.uid,
            offset: _app.logList.length,
            limit: PAGE_SIZE
          },
          response => {
            _app.loadingEnd = response.cash_list.length < PAGE_SIZE;
            _app.logList = _app.logList.concat(response.cash_list);
          },
          (code, msg) => {
            showToast(msg);
          }
        );
      }
    },
  },
}
</script>
